const JOIN_OPERATOR = ", "
const PIPE_SEPARATOR = "| "

const SORT_ORDER = {
  ASC: "asc",
  DESC: "desc"
}

const ACTION_TYPE = {
  PRIMARY: "primary",
  SECONDARY: "secondary"
}

const DATE_STRING_OPTIONS = {
  NUMERIC: "numeric",
  SHORT: "short",
  LONG: "long",
  TWO_DIGIT: "2-digit"
}

export { JOIN_OPERATOR, PIPE_SEPARATOR, SORT_ORDER, ACTION_TYPE, DATE_STRING_OPTIONS };